"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../../json"));
const openapi_1 = require("../../../../openapi");
const guard_1 = require("../guard");
const DeviceSchema = __importStar(require("../job/schema"));
const Command = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.Command.Spec';
const CommandSentResponse = openapi_1.Response.Success(Command.CommandSent).annotations({
    description: 'The command was sent to the device (delivery is not confirmed)',
});
const CreatedJobResponse = openapi_1.Response.Success(DeviceSchema.CreatedJob).annotations({
    description: 'The on-demand command job was created',
});
const CommandHistoryResponse = openapi_1.Response.Success(Command.CommandHistory).annotations({
    description: 'Command history for a device',
});
const CommandParseValidation = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.CommandParseValidation`, 'INVALID_REQUEST', 'Validation Error (Effect ParseError)', 'The command payload does not match the DeviceCommand schema; inputValidation.message is the formatted ParseError text.', { inputValidation: effect_1.Schema.Struct({ _id: effect_1.Schema.Literal('ParseError'), message: effect_1.Schema.String }) });
const HubNotConfigured = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.HubNotConfigured`, 'HUB_NOT_CONFIGURED', 'Hub Not Configured', 'The IoT Hub is not configured for this device.', { payload: Json.Record, details: Json.Value });
/*
 * 408/503, not 422: v1Rejected is fixed at 422 and does not apply here.
 */
const MessageAckTimeout = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('MESSAGE_ACK_TIMEOUT'),
        payload: Json.Record,
        details: Json.Value,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.MessageAckTimeout`,
    title: 'Message Acknowledgement Timeout',
    description: 'The device did not acknowledge the command in time.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 408,
});
const ServiceUnavailable = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('SERVICE_UNAVAILABLE'),
        payload: Json.Record,
        details: Json.Value,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ServiceUnavailable`,
    title: 'Service Unavailable',
    description: 'The IoT Hub messaging service is unavailable.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 503,
});
const HistoryQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.NonEmptyString,
    userId: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
});
const sendCommand = platform_1.HttpApiEndpoint.post('sendCommand') `/command`
    .setPayload(Command.SendCommandPayload)
    .addSuccess(CommandSentResponse)
    .addSuccess(CreatedJobResponse, { status: 201 })
    .addError(CommandParseValidation)
    .addError(HubNotConfigured)
    .addError(openapi_1.Error.V1NotFound)
    .addError(MessageAckTimeout)
    .addError(ServiceUnavailable)
    .annotate(platform_1.OpenApi.Title, 'Send Device Command')
    .annotate(platform_1.OpenApi.Description, 'Sends a command to a device through the synchronous instantMessage Direct Method. ' +
    'The device response itself is not returned, only recorded in the command history. ' +
    '404 covers both NOT_FOUND and NOT_CONNECTED. ' +
    '403 NOT_ALLOWED when the caller may not operate the device. 429 covers TOO_MANY_REQUESTS and OVER_QUOTA. ' +
    '422 HUB_NOT_CONFIGURED when the IoT Hub is not configured for the device. ' +
    'deferrable: true creates an on-demand command job instead (201), without checking device permission.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getCommandHistory = platform_1.HttpApiEndpoint.get('getCommandHistory') `/command/history`
    .setUrlParams(HistoryQuery)
    .addSuccess(CommandHistoryResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Device Command History')
    .annotate(platform_1.OpenApi.Description, '90 days, newest first, no pagination. userId is optional (any caller may filter by any user). ' +
    'Does not check the caller has permission to operate the device. ' +
    'A history record with an unknown appId currently answers 500.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getUserCommandHistory = platform_1.HttpApiEndpoint.get('getUserCommandHistory') `/command/history/user`
    .setUrlParams(effect_1.Schema.Struct({ serialNumber: effect_1.Schema.NonEmptyString }))
    .addSuccess(CommandHistoryResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Own Device Command History')
    .annotate(platform_1.OpenApi.Description, 'Same as GET /command/history, restricted server-side to the calling user (userId is not a client field here).')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.device.command')
    .add(sendCommand)
    .add(getCommandHistory)
    .add(getUserCommandHistory)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Device Commands')
    .annotate(platform_1.OpenApi.Description, 'Admin device command endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map